export const PAY_METHODS = {
  'cash': 'наличные',
  'bank': 'банковский перевод',
  'card': 'карта'
};
